import React, { useEffect as _useEffect } from 'react'
import { useAppSelector as _useAppSelector } from '@/hooks'
import { getSixLawsImageUrl } from '@/assets/images/SixLawsPage/imageMap'
import './index.less'

export default function Position(props) {
  const { currentTags, currentImgSrc, class1 } = props
  // console.log(currentImgSrc, "currentImgSrc")
  // console.log(currentTags, "currentTags")
  // const class1 = useAppSelector((state) => state.paintingIntroInfo.class1)
  // console.log(currentImgSrc, "positioncurrentImgSrc")
  console.log(class1, 'positionclass1')
  console.log(currentTags, 'currentTags')

  // useEffect(() => {
  //   console.log(currentImgSrc, "currentImgSrc")
  // }, [currentImgSrc])
  // console.log(class1,"class1");
  // console.log(currentTags,"currentTags");

  // display = () => {
  //   if (A) {
  //     return (<div />)
  //   }
  // }

  return (
    <div className='position-wrapper'>
      <div className='inner-position'>
        {currentTags.map((item) => {
          return (
            <div className='position-tags' key={item}>
              {item}
            </div>
          )
        })}
        {/* 固定的几种构图方式+后端给的打标信息 */}
        <div className='position-pic'>
          {class1 === '人物' && currentTags[0] === '叙事性构图' ? (
            <>
              <div className='special-pic'>例如洛神赋图。</div>
            </>
          ) : class1 === '人物' && currentTags[0] === '长卷式构图' ? (
            <>
              <div className='special-pic'>例如簪花仕女图。</div>
            </>
          ) : class1 === '人物' && currentTags[0] === '中心构图' ? (
            <>
              <div className='special-pic'>例如琵琶美人图。</div>
            </>
          ) : currentImgSrc.length > 0 ? (
            <div className='position-image'>
              <img src={getSixLawsImageUrl(currentImgSrc)} alt='' className='position-pic' />
            </div>
          ) : null}
        </div>
        {/* {currentImgSrc.length > 0 ? (
          <>
            <div className="position-image">
              <img
                src={require("../../../assets/images/SixLawsPage" + currentImgSrc)}
                alt=""
                className="position-pic"
              />
            </div>
          </>
        ) : null} */}
      </div>
    </div>
  )
}
